import React from "react";
import ChevronDown from "../../../../../shared/svg/chevron-down";
import AssignTo from "../../../assignTo/assignTo";
import UserNameWithInitials from "../../../userNameWithInitials/userNameWithInitials";

interface UserInitialsCellProps {
  value: { assigneeId: string; assignee: string };
  handleAssignToClick?: (data: any) => void;
  [key: string]: any;
}

export const UserInitialsCell: React.FC<UserInitialsCellProps> = ({
  value,
  handleAssignToClick,
}) => {
  const handleAssignToClickHandler = (data: any) => {
    if (handleAssignToClick) {
      handleAssignToClick(data);
    }
  };

  return (
    <>
      {value.assigneeId === "" ? (
        <div onClick={() => handleAssignToClickHandler(value)}>
          <AssignTo />
        </div>
      ) : (
        <div className="assign-to-container flex w-fit max-w-full items-center gap-1 rounded-[1.875rem] border border-primaryGray-15 px-1 py-[0.375rem]">
          <div
            className="initial-name-container overflow-hidden"
            onClick={() => handleAssignToClickHandler(value)}
          >
            <UserNameWithInitials name={value.assignee} height="1.5rem" />
          </div>
          <div className="initials-icon">
            <ChevronDown />
          </div>
        </div>
      )}
    </>
  );
};

export default UserInitialsCell;
